import React, { useId } from 'react';
import './Field.css';

export function Field({
  label,
  name,
  type = 'text',
  as = 'input',
  error,
  hint,
  options,
  className = '',
  ...rest
}) {
  const id = useId();
  const describedBy = [error ? `${id}-err` : null, hint ? `${id}-hint` : null]
    .filter(Boolean)
    .join(' ');

  const shared = {
    id,
    name,
    'aria-invalid': error ? 'true' : undefined,
    'aria-describedby': describedBy || undefined,
    className: 'field__control',
    ...rest,
  };

  return (
    <div className={`field${error ? ' has-error' : ''}${className ? ` ${className}` : ''}`}>
      <label className="field__label" htmlFor={id}>
        {label}
        {rest.required ? <span className="field__req" aria-hidden="true"> *</span> : null}
      </label>

      {as === 'textarea' ? (
        <textarea rows={5} {...shared} />
      ) : as === 'select' ? (
        <select {...shared}>
          {options.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      ) : (
        <input type={type} {...shared} />
      )}

      {hint ? (
        <p className="field__hint" id={`${id}-hint`}>
          {hint}
        </p>
      ) : null}
      {error ? (
        <p className="field__error" id={`${id}-err`} role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}

/** Radio-style segmented control — used for choosing a branch. */
export function ChoiceGroup({ label, name, value, onChange, options, error }) {
  return (
    <fieldset className={`choice${error ? ' has-error' : ''}`}>
      <legend className="field__label">{label}</legend>
      <div className="choice__row">
        {options.map((o) => (
          <label key={o.value} className={`choice__item${value === o.value ? ' is-active' : ''}`}>
            <input
              type="radio"
              name={name}
              value={o.value}
              checked={value === o.value}
              onChange={() => onChange(o.value)}
            />
            <span className="choice__name">{o.label}</span>
            {o.hint ? <span className="choice__hint">{o.hint}</span> : null}
          </label>
        ))}
      </div>
      {error ? (
        <p className="field__error" role="alert">
          {error}
        </p>
      ) : null}
    </fieldset>
  );
}
